import { MeetingDetails, getTeamListForMeetingNotes } from "api";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import moment from "moment";
import { useEffect } from "react";
import { useUser } from "stores/useUser";
import { notify } from "utils/common";
import { parseFetchedEvents } from "utils/events";
import { FirestoreDB } from "utils/firebase";
import useWorkspaceStore from "../stores/useWorkspaceStore";

const useEvents = () => {
  const { user } = useUser();
  const {
    events,
    setMetaData,
    setEvents,
    setLoading,
    setError,
    setMetaDataLoading,
    setMetaDataError,
    selectedDate,
  } = useWorkspaceStore();
  useEffect(() => {
    const fetchMetaData = async (events) => {
      if (events?.length > 0) {
        try {
          setMetaDataLoading(true);
          const eventIds = events.map((event) => event.eventId);
          const response = await MeetingDetails(
            user.email,
            eventIds,
            user?.subscription?.organization_id
          );
          setMetaData(response.data);
        } catch (error) {
          notify("Error while fetching metadata", "error");
          setMetaDataError(true);
        } finally {
          setMetaDataLoading(false);
        }
      }
    };
    fetchMetaData(events);
  }, [events, setMetaDataError, setMetaDataLoading, setMetaData, user]);

  //* fetch data of current date when date changes and on first load
  useEffect(() => {
    setLoading(true);
    console.log("FETCHING EVENTS");
    // query to fetch events of the selected date
    const q = query(
      collection(FirestoreDB, `users/${user.uid}/calendarEvents`),
      where(
        "start.dateTime",
        ">=",
        moment(selectedDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
      ),
      where(
        "start.dateTime",
        "<=",
        moment(selectedDate).format("YYYY-MM-DD") + "T23:59:59.999Z"
      )
    );

    try {
      const unsubscribeCalendarData = onSnapshot(q, async (querySnapshot) => {
        const res = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // Defensive: never render a cancelled event even if one lands here.
          if (data?.status === "cancelled") return;
          res.push(data);
        });
        console.log("Number of Event fetched: ", res.length);
        setEvents(parseFetchedEvents(user, res));
        setLoading(false);
      });

      // * unsubscribe the listener when component unmounts
      return () => {
        console.log("UNSUBSCRIBING EVENTS");
        unsubscribeCalendarData();
      };
    } catch (err) {
      notify("Error while fetching events", "error");
      setLoading(false);
      setError(true);
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  // * fetch strategic goals
  // useEffect(() => {
  //   let unsubscribeGoals; // Declare the variable here

  //   const getGoals = async () => {
  //     try {
  //       if (!strategicGoals) {
  //         const res = await getDoc(
  //           doc(
  //             FirestoreDB,
  //             "organizations",
  //             user?.subscription?.organization_id
  //           )
  //         );
  //         setStrategicGoals(res?.data()?.goals);
  //       }
  //     } catch (err) {
  //       console.log(err);
  //       notify(err.message, "error");
  //     }
  //   };

  //   if (user?.subscription?.plan === "ENTERPRISE" && strategicGoals === null) {
  //     getGoals();
  //   }

  //   return () => {
  //     if (unsubscribeGoals) {
  //       unsubscribeGoals(); // Use the variable here
  //     }
  //   };
  // }, []);

  return {};
};

export default useEvents;
